import { render, staticRenderFns } from "./SfTextarea.vue?vue&type=template&id=21f280d6&functional=true"
import script from "./SfTextarea.vue?vue&type=script&lang=js"
export * from "./SfTextarea.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfTextarea.vue?vue&type=style&index=0&id=21f280d6&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "292349e7"
  
)

export default component.exports